import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { ImportSupplier } from '../../models/import-supplier';
import { addOrUpdateImportSuppliers, deleteImportSupplier, fetchImportSuppliers } from './import-suppliers-actions';

export interface ImportSuppliersReducerState {
    importSuppliers: PaginatedResponse<ImportSupplier>;
    requesting: boolean;
}

export const initialImportSuppliersReducerState: ImportSuppliersReducerState = {
    importSuppliers: { limit: 30, page: 1, total: 0, items: [] },
    requesting: false,
};

export const importSuppliersReducer = createReducer(initialImportSuppliersReducerState, builder =>
    builder
        .addCase(fetchImportSuppliers.pending, state => {
            state.requesting = true;
        })
        .addCase(fetchImportSuppliers.fulfilled, (state, action) => {
            state.importSuppliers = action.payload;
            state.requesting = false;
        })
        .addCase(fetchImportSuppliers.rejected, state => {
            state.requesting = false;
        })
        .addCase(deleteImportSupplier.fulfilled, (state, action) => {
            state.importSuppliers.items = state.importSuppliers.items.filter(item => item.id !== action.payload);
            state.importSuppliers.total = state.importSuppliers.total - 1;
        })
        .addCase(addOrUpdateImportSuppliers.fulfilled, (state, action) => {
            const id = action.payload.id;
            const newItem = action.payload.result;

            if (id) {
                state.importSuppliers.items = state.importSuppliers.items.map(item =>
                    item.id === id ? newItem : item
                );
            } else {
                state.importSuppliers.items.push(newItem);
                state.importSuppliers.total = state.importSuppliers.items.length;
            }
        })
);
